const decodeBase64Url = (input) => {
  // base64url -> base64
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  // pad
  const padded = base64 + '==='.slice((base64.length + 3) % 4);

  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    // atob returns a binary string; JWT JSON is ASCII/UTF-8 safe in practice
    return window.atob(padded);
  }

  // Node/build fallback (build tools / tests)
  // eslint-disable-next-line no-undef
  return Buffer.from(padded, 'base64').toString('utf8');
};

const parseJson = (s) => {
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
};

export const decodeJWT = (token) => {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;

  const headerJson = decodeBase64Url(parts[0]);
  const payloadJson = decodeBase64Url(parts[1]);

  const header = parseJson(headerJson);
  const payload = parseJson(payloadJson);

  if (!header && !payload) return null;
  return { header, payload };
};
